import { Entypo } from "@expo/vector-icons";
import { Pressable, StyleSheet } from "react-native";
import variables from "../assets/variables";

const ToggleView = ({ squaredView, setSquaredView, style = {} }) => {
  return (
    <Pressable
      style={style || styles.gridToggle}
      onPress={() => setSquaredView(!squaredView)}
      hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
    >
      <Entypo
        name={squaredView ? "grid" : "list"}
        size={24}
        color={variables.$textLight}
      />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  gridToggle: {
    marginRight: 10,
  },
});

export default ToggleView;
